import { IAudienceQuery } from 'app/library/audience/interfaces/audience.query.interface';
import { IUserQuery } from 'app/projects/user/src/lib/interfaces/user.query.interface';
import { IAudienceUserQuery } from '../interfaces/audience-user.query.interface';

export type AudienceUserApiItem = IAudienceUserQuery &
    Partial<IAudienceQuery> & {
        audience_id?: number;
    };

function isFlatAudienceShape(item: AudienceUserApiItem): boolean {
    return item != null && item.audience == null && item.name != null && item.id != null;
}

export function normalizeAudienceUserQuery(item: AudienceUserApiItem, userId: string): IAudienceUserQuery {
    const user = item.user ?? ({ id: Number(userId) } as IUserQuery);

    if (item.audience) {
        return { ...item, user };
    }

    if (isFlatAudienceShape(item)) {
        return {
            id: item.id,
            audience: item as unknown as IAudienceQuery,
            user,
        };
    }

    if (item.audience_id != null) {
        return {
            id: item.id,
            audience: { id: String(item.audience_id) } as IAudienceQuery,
            user,
        };
    }

    return { ...item, user };
}
